module.exports = __webpack_public_path__ + "img/garden.12d88d08.jpg";